export enum ImportContactsModalStep {
  upload,
  mapping,
  review,
  addToGroups,
}
